export default {
      id: "therapeutic-goal-usage",
      viewBox: "0 0 70 70",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#therapeutic-goal",
      toString: function () {
        return this.url;
      }
    }